// Tenantra Inc. - Late-payment risk watchlist: explainable 0–100 score per tenant from the last 12 months
import { Card, money, plural } from './kit';

const LEVEL = { high: 'bg-red-50 text-red-700', medium: 'bg-amber-50 text-amber-700' };

export function RiskWatchlist({ risk, onTenant }) {
  const { watchlist, counts, not_enough_history: thin } = risk;
  return (
    <Card title="Late-payment risk" aside={`${counts.high} high · ${counts.medium} medium · ${counts.low} low`} testId="risk-watchlist">
      {watchlist.length === 0 ? <p className="px-5 pb-5 text-sm text-slate-500" data-testid="risk-empty">No one looks likely to pay late next month.</p> : (
        <ul className="divide-y divide-slate-100">
          {watchlist.map(r => (
            <li key={r.tenancy_id}>
              <button type="button" onClick={() => onTenant(r.tenant_id)} className="w-full text-left px-5 py-3 flex items-start gap-3 hover:bg-slate-50/80 transition-colors" data-testid={`risk-row-${r.tenancy_id}`}>
                <span className={`flex-shrink-0 w-10 h-10 rounded-lg grid place-items-center text-sm font-semibold tabular-nums ${LEVEL[r.level]}`} title={`${r.level} risk`} data-testid={`risk-score-${r.tenancy_id}`}>{r.score}</span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-baseline justify-between gap-3">
                    <p className="text-sm text-slate-800 truncate">{r.tenant}</p>
                    {r.owing > 0 && <span className="text-xs text-red-700 tabular-nums flex-shrink-0">{money(r.owing)} owing</span>}
                  </div>
                  <p className="text-xs text-slate-500 truncate">{r.where}</p>
                  <div className="flex flex-wrap gap-1 mt-1.5">
                    {r.reasons.map(x => <span key={x} className={`text-[11px] px-1.5 py-0.5 rounded ${x.startsWith('On time') ? 'bg-emerald-50 text-emerald-700' : 'bg-slate-100 text-slate-600'}`}>{x}</span>)}
                  </div>
                </div>
              </button>
            </li>
          ))}
        </ul>
      )}
      <p className="px-5 py-3 text-[11px] text-slate-400 border-t border-slate-100">Score: late, partial and missed months, returned payments, open disputes, money owing and whether payments are getting later. On-time streaks lower it.{thin > 0 && ` ${plural(thin, 'tenant')} without enough history yet.`}</p>
    </Card>
  );
}
